import React from 'react';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { Badge } from '../ui/badge';

const STATUS_CONFIG = {
  success: { color: 'bg-green-500/20 text-green-400', icon: CheckCircle },
  failed: { color: 'bg-red-500/20 text-red-400', icon: XCircle },
  pending: { color: 'bg-yellow-500/20 text-yellow-400', icon: Clock }
};

export const StatusBadge = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = cfg.icon;
  
  return (
    <Badge className={cfg.color}>
      <Icon className="w-3 h-3 mr-1" />
      {status}
    </Badge>
  );
};

export default StatusBadge;
